module.exports = __webpack_public_path__ + "img/browser_ab-2.da4e4bdd.png";